"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKColorLegend = exports.determineScrollClasses = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TDOD: fix jsx-a11y
var React = __importStar(require("react"));
var common_1 = require("../../common");
var components_1 = require("../../components");
var models_1 = require("../../models");
require("./GKColorLegend.css");
// Wraps the legend in a GKBottomDrawer-esque wrapper component that uses GKCollapse.
var DrawerWithLegend = function (props) { return (React.createElement("div", { "data-qa": props.dataQa, className: "gk-color-legend-drawer-container" },
    React.createElement("div", { className: "gk-bottom-drawer-toggle flex-grow-0 text-center", onClick: props.onClick },
        React.createElement("div", { className: "gk-color-legend-title" }, props.title),
        React.createElement(components_1.GKIcon, { name: props.isOpen
                ? components_1.GKIconName.KeyboardArrowDown
                : components_1.GKIconName.KeyboardArrowUp })),
    React.createElement(components_1.GKCollapse, { isOpen: props.isOpen }, props.children))); };
// Determines whether the current ref has overflowing content (and should scroll).
// Sits outside of the component for testing purposes.
var determineScrollClasses = function (ref, orientation) {
    if (orientation === void 0) { orientation = models_1.Orientation.Horizontal; }
    if (!(ref === null || ref === void 0 ? void 0 : ref.current)) {
        return undefined;
    }
    if (orientation === models_1.Orientation.Horizontal) {
        return ref.current.scrollWidth > ref.current.clientWidth
            ? "scroll-horizontal"
            : undefined;
    }
    return ref.current.scrollHeight > ref.current.clientHeight
        ? "scroll-vertical"
        : undefined;
};
exports.determineScrollClasses = determineScrollClasses;
/**
 * Color legend for use with maps and charts. Provides a card containing title, subtitle, help text,
 * as well as a range of discrete color boxes or gradient with accompanying keys/labels.
 * Can render inside a collapsible drawer if collapseAtMobile = true
 */
var GKColorLegend = function (props) {
    var _a;
    // Props.
    var _b = (0, common_1.mapDefaultProps)(props, { _gkComponentName: "gk-color-legend" }), className = _b.className, collapseAtMobile = _b.collapseAtMobile, dataQa = _b["data-qa"], onSelection = _b.onSelection, selection = _b.selection, options = _b.options, otherProps = __rest(_b, ["className", "collapseAtMobile", "data-qa", "onSelection", "selection", "options"]);
    // Non-state hooks.
    var wCtx = React.useContext(common_1.WindowSizeContext);
    var cardRef = React.useRef(null);
    var currentOptions = (0, common_1.useResponsive2)(options || {});
    var uniqueId = (0, common_1.usePersistentId2)(props.id);
    var _c = currentOptions || {}, helpText = _c.helpText, selectionText = _c.selectionText, subtitle = _c.subtitle, title = _c.title, rangeProps = __rest(_c, ["helpText", "selectionText", "subtitle", "title"]);
    // State hooks.
    var _d = React.useState(), scrollClass = _d[0], setScrollClass = _d[1];
    var _e = React.useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var setScroll = function () {
        setScrollClass((0, exports.determineScrollClasses)(cardRef, currentOptions === null || currentOptions === void 0 ? void 0 : currentOptions.orientation));
    };
    // Effects
    React.useEffect(function () {
        window.addEventListener("resize", setScroll);
        return function () { return window.removeEventListener("resize", setScroll); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentOptions]);
    React.useLayoutEffect(function () {
        window.setTimeout(setScroll, 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    var isInADrawer = collapseAtMobile && wCtx.isMobileSized;
    var isSelectable = onSelection && rangeProps.type === "discrete";
    var allSelected = (selection === null || selection === void 0 ? void 0 : selection.length) === ((_a = rangeProps.keys) === null || _a === void 0 ? void 0 : _a.length);
    // Handle selections
    var selectAll = function () {
        var _a;
        onSelection === null || onSelection === void 0 ? void 0 : onSelection(((_a = rangeProps.keys) === null || _a === void 0 ? void 0 : _a.map(function (key) { return key.payload; })) || []);
    };
    var unselectAll = function () {
        onSelection === null || onSelection === void 0 ? void 0 : onSelection([]);
    };
    // Renders the actual color legend.
    var Legend = function () {
        var helpRef = React.useRef(null);
        return (React.createElement(components_1.GKCard, __assign({ className: "" + className + (isSelectable ? " selectable" : " "), "data-qa": dataQa }, otherProps),
            (title || subtitle || helpText || selectionText) && (React.createElement(components_1.GKCardHeader, { "data-qa": dataQa + "--header", className: "p-0 border-bottom-0" },
                React.createElement("div", { className: "d-flex p-0 border-bottom " + (isInADrawer ? "flex-nowrap" : "flex-wrap flex-md-nowrap") },
                    title && !isInADrawer && (React.createElement(components_1.GKCardTitle, { "data-qa": dataQa + "--title", className: "d-flex m-0 px-2 px-sm-3 py-1 py-md-2 order-0" },
                        React.createElement("span", { className: "my-auto" }, title))),
                    subtitle && (React.createElement(components_1.GKCardSubtitle, { "data-qa": dataQa + "--subtitle", className: "d-flex m-0 px-2 px-sm-3 py-1 py-md-2 " + (isInADrawer ? "order-0" : "order-2") + " order-md-1" },
                        React.createElement("span", { className: "my-auto" }, subtitle))),
                    isSelectable && selectionText && (React.createElement(components_1.GKCardText, { "data-qa": dataQa + "--selectionText", className: "d-flex m-0 px-2 px-sm-3 py-1 py-md-2 ml-auto order-1 order-md-2" },
                        React.createElement(components_1.GKButton, { className: "m-auto", color: "link", onClick: allSelected ? unselectAll : selectAll }, allSelected
                            ? selectionText.unselect
                            : selectionText.select))),
                    helpText && (React.createElement(React.Fragment, null,
                        React.createElement("div", { ref: helpRef, id: uniqueId + "-help", "data-qa": dataQa + "--helpText", className: "gk-color-legend-help d-flex px-2 px-sm-3 py-1 py-md-2 border-left text-primary order-1 order-md-2 " + (isSelectable && selectionText ? "" : "ml-auto") },
                            React.createElement(components_1.GKIcon, { className: "my-auto", name: components_1.GKIconName.HelpOutline })),
                        React.createElement(components_1.GKTooltip, { target: helpRef }, helpText)))))),
            React.createElement("div", { "data-qa": dataQa + "--body", className: "gk-card-body card-body " + (scrollClass || ""), ref: cardRef },
                React.createElement(components_1.GKColorRange, __assign({ "data-qa": dataQa + "--color-range", id: uniqueId + "--color-range", selection: selection, onSelection: onSelection }, rangeProps)))));
    };
    // Wrap the legend at mobile; just return the legend otherwise.
    return isInADrawer ? (React.createElement(DrawerWithLegend, { dataQa: dataQa + "--drawer-container", isOpen: isOpen, onClick: function () { return setIsOpen(!isOpen); }, title: title || "" },
        React.createElement(Legend, null))) : (React.createElement(Legend, null));
};
exports.GKColorLegend = GKColorLegend;
exports.default = exports.GKColorLegend;
